import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AgGridActionbutton } from 'src/app/shared/common/AgGridActionbutton';
import { JSIGNALBUTTON } from 'src/app/shared/common/JsignalButtons';
import { JsignalService } from 'src/app/shared/services/jsignal.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { CreateFormulaPopUpComponent } from './create-formula-pop-up/create-formula-pop-up.component';
import { constants } from "src/app/shared/common/contants";

@Component({
    selector: 'app-formula-builder',
    templateUrl: './formula-builder.component.html',
    styleUrls: ['./formula-builder.component.scss'],
    standalone: false
})
export class FormulaBuilderComponent implements OnInit, OnDestroy {

  formulaOptions: any[] = [
    { label: 'Formula 1', value: 'formula1' },
    { label: 'Formula 2', value: 'formula2' },
    { label: 'Formula 3', value: 'formula3' }
  ];
  
formulaType = [
  { formulaType: 'Analytic' },
  { formulaType: 'Statistical' }
];

  gridApi: any;

  // 
  searchSubject: Subject<string> = new Subject<string>();
  destroy$: Subject<void> = new Subject<void>();

  rowData: any[] = [];
  columnDefs: any;
  defaultColDef: any;

  // (avoid undefined)
  components: any = {};
    variables = [];

  isGridLoading = true;
  gridOptions: { rowHeight: number };
  getRowStyle: (params: any) => { backgroundColor: string };

  selectedFormula: any = null;
  selectedFormulaType: any = null;
  originalData: any[] = []; // full grid data
  filteredData: any[] = []; // data shown in grid
  rowClassRules: { sick: (params: any) => boolean; };

  constructor(
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private localStorageSettings: LocalStorageSettingsService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private constants: constants
  ) {   this.components = {
      jsignalButton: JSIGNALBUTTON,
      buttonRenderer: AgGridActionbutton
    };}

  ngOnInit(): void {

    this.searchSubject.pipe(
      debounceTime(300),
      takeUntil(this.destroy$)
    ).subscribe(searchTerm => {
      if (this.gridApi) {
        this.gridApi.setGridOption('quickFilterText',searchTerm);
      }
    });

    this.intializeGrid();
    this.loadFormulas();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  intializeGrid() {

    this.columnDefs = [
      {
        headerName: "Name",
        field: "formulaName",
       width: 200,
        ...this.jsignalsService.autoTooltip("Name"),
      },
      {
        headerName: "Description",
        field: "formulaDesc",
        width: 250,
        ...this.jsignalsService.autoTooltip("Description"),
      },
      {
        headerName: "Expression",
        field: "expression",
          width: 300,
        ...this.jsignalsService.autoTooltip("Expression"),
      },
      {
        headerName: "Formula Type",
        field: "formulaType",
      width: 180,
        ...this.jsignalsService.autoTooltip("Formula Type"),
      },

      {
        headerName: "Variables",
        field: "variables",
       width: 220,
        valueGetter: (params: any) =>
          params.data?.variables?.map((v: any) => v.formulaName).join(", ") || "",
        ...this.jsignalsService.autoTooltip("Variables"),
      },
      {
        headerName: "Status",
        field: "status",
       width: 120,
        ...this.jsignalsService.autoTooltip("Status"),
      },
      {
        headerName: "Created By",
        field: "createdBy",
       width: 180,
        ...this.jsignalsService.autoTooltip("Created By"),
      },
      {
        headerName: "Created At",
        field: "createdDate",
       width: 180,
        ...this.jsignalsService.autoTooltip("Created At"),
      },
      {
        headerName: "Last Modified By",
        field: "lastModifiedBy",
       width: 180,
        
        ...this.jsignalsService.autoTooltip("Last Modified By"),
      },
      {
        headerName: "Last Modified Date",
        field: "lastModifiedDate",
       width: 180,
        
        ...this.jsignalsService.autoTooltip("Last Modified Date"),
      },
      {
        headerName: "Action",
        filter: false,
     
        width: 180,
        cellRenderer: "buttonRenderer",
        pinned: "right",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }),
      },
    ];

    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

// if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.getRowStyle = (params: any) => {
      console.log(params);
      console.log(params.rowData.status);
      if (params.rowData.status === "No") {
        return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
  }

  EditIcon(params: any) {
     const rowData = params.rowData;
     console.log("Edit clicked for:", rowData); 

  if (params.rowData.status === "No") {
    this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
    return;
  }

    let dialogRef = this.dialog.open(CreateFormulaPopUpComponent, {
      width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
    data: { formula: rowData,variables: this.variables } // Pass any initial data if needed
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log('Formula update:', result);
      // Handle the form result here
      // You can set it to your editor or process it as needed
      // this.editor.setValue(result.sqlFormula || result.mathematicalFormula);
      this.updateFormula(rowData.formulaId,result);
    }
  });
  }
  deleteIcon(params: any) {
    const rowData = params.rowData;
    console.log("Delete clicked for:", rowData.formulaId);

  if (params.rowData.status === "No") {
    this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
    return;
  }
    
    this.spinner.start();
    this.jsignalsService
      .deleteFormula(rowData.formulaId)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
             this.loadFormulas();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadFormulas();
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
          this.loadFormulas();
        },
      });  
  }

  loadFormulas() {
     
    this.spinner.start();
    this.jsignalsService
      .getAllFormulas()
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.rowData = [];
            this.spinner.stop();
    
            return;
          }
          this.rowData = res;
          this.formulaOptions=res;
          this.originalData = res;
          this.filteredData = res;
          
          this.variables = res;
          
          console.log(this.variables);
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.rowData = [];
          this.spinner.stop();
         
        },
      });  
  }

  onCreate() {
  let dialogRef = this.dialog.open(CreateFormulaPopUpComponent, {
      width: "90%",
        autoFocus: false,
        maxWidth: '100vw',
        height: "95%",
        disableClose: true,
    data: { variables: this.variables } // Pass any initial data if needed
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log('Formula created:', result);
      // Handle the form result here
      // You can set it to your editor or process it as needed
      // this.editor.setValue(result.sqlFormula || result.mathematicalFormula);
      this.createFormula(result);
    }
  });
}

  onSearch(event: Event): void {
    const value = (event.target as HTMLInputElement)?.value || '';
    this.searchSubject.next(value);
  }

  clearSearch(inputElement: HTMLInputElement): void {
    inputElement.value = '';
    this.searchSubject.next('');
  }

  // FIXED FILTER FIELD
onFilterChange(filterType: string, value: any) {
  if (filterType === 'formula') {
    this.selectedFormula = value;
  } else if (filterType === 'type') {
    this.selectedFormulaType = value;
  }

  this.applyFilters();
}

        applyFilters() {
      this.filteredData = this.originalData.filter(item => {

        const formulaMatch = this.selectedFormula
          ? item.formulaName === this.selectedFormula
          : true;

        const typeMatch = this.selectedFormulaType
          ? item.formulaType === this.selectedFormulaType
          : true;

        return formulaMatch && typeMatch;
      });
    }

  onFormulaTypeFilter(value: any): void {
    if (!this.gridApi) return;

    if (!value) {
      this.gridApi.setFilterModel(null);
      return;
    }

    const filterInstance = this.gridApi.getFilterInstance('formulaType');
    filterInstance?.setModel({
      type: 'equals',
      filter: value
    });

    this.gridApi.onFilterChanged();
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.isGridLoading = false;

    // ✅ ENSURE ROW DATA BINDS
    if (this.rowData?.length) {
      this.gridApi.setGridOption('rowData', this.rowData);
    }

    // setTimeout(() => {
    //   if (this.gridApi) {
    //     this.gridApi.sizeColumnsToFit();
    //   }
    // }, 100);
  }

  // refreshData(): void {
  //   this.isGridLoading = true;

  //   setTimeout(() => {
  //     this.isGridLoading = false;
  //     if (this.gridApi) {
  //       this.gridApi.refreshCells();
  //     }
  //   }, 1000);
  // }

  onDownload() {
    console.log("Download clicked");
    // export logic (CSV / Excel)

    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "Formula.csv",
      });

      this.spinner.stop();
    }, 500);
  }

  createFormula(FormulaData: any) {
    console.log("Creating formula");
    this.spinner.start();
    this.jsignalsService
      .createFormula([FormulaData])
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
             this.loadFormulas();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadFormulas();
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
          this.loadFormulas();
        },
      });  
  }

  updateFormula(id:any, FormulaData: any) {
    console.log("updating formula",id,FormulaData);
    this.spinner.start();
    this.jsignalsService
      .updateFormula(id, FormulaData)
      .subscribe({
        next: (res: any) => {
          console.log(res);
          if(res.error == true){
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
             this.loadFormulas();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
           this.loadFormulas();
          this.spinner.stop();
          
        },
        error: (err) => {
          console.error("error:", err);
          this.snackBar.open(err.error.statusMessage, "Ok", {
            duration: 3000,
          });
          this.spinner.stop();
          this.loadFormulas();
        },
      });  

  }
}
